import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { Button } from '../Button';
import { useAuth } from '../../contexts/AuthContext';
import { ROUTES } from '../../utils/constants';

export function FinalCTA() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handlePrimaryClick = () => {
    if (isAuthenticated) {
      navigate(ROUTES.DASHBOARD);
    } else {
      navigate('/register');
    }
  };

  const trustPoints = [
    'Free plan available',
    'No credit card required',
    'Upgrade anytime',
  ];

  return (
    <section className="bg-white relative overflow-hidden section-padding">
      {/* Solid background with subtle accent */}
      <div className="absolute inset-0 bg-white" />

      {/* Subtle dot pattern for texture (replaces blur elements) */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, var(--clinqr-navy) 1px, transparent 1px)`,
          backgroundSize: '32px 32px',
        }}
      />

      {/* Geometric accent shape */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[--clinqr-navy]/5 rounded-[60px] -rotate-12 translate-x-1/3 -translate-y-1/3" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[--clinqr-navy]/5 rounded-[60px] rotate-12 -translate-x-1/3 translate-y-1/3" />

      <div className="relative container-page text-center">
        {/* Headline */}
        <h2 className="heading-1 text-[--clinqr-navy] mb-4 sm:mb-6">
          Ready to Create Smarter QR Codes?
        </h2>

        {/* Subheadline */}
        <p className="text-base sm:text-lg lg:text-xl text-[--clinqr-navy]/60 max-w-2xl mx-auto mb-8 sm:mb-10 font-medium">
          Start routing your audience to the right content, every time.
          <br className="hidden sm:block" />
          No credit card required.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8 sm:mb-10">
          <Button
            variant="primary"
            className="px-10 h-14 shadow-2xl w-full sm:w-auto text-lg"
            onClick={handlePrimaryClick}
          >
            {isAuthenticated ? 'Go to Dashboard' : 'Get Started Free'}
          </Button>
          <Button
            variant="secondary"
            className="px-10 h-14 font-bold w-full sm:w-auto text-lg"
            onClick={() => navigate('/pricing')}
          >
            View Pricing
          </Button>
        </div>

        {/* Trust Points */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-10">
          {trustPoints.map((point, index) => (
            <div key={index} className="flex items-center gap-3 text-[--clinqr-navy]/60">
              <div className="w-6 h-6 rounded-full bg-[--clinqr-navy]/10 flex items-center justify-center shadow-inner">
                <Check className="w-3.5 h-3.5 text-[--clinqr-navy]" strokeWidth={4} />
              </div>
              <span className="text-sm sm:text-base font-bold tracking-tight">{point}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
